export enum AnalyticsEventType {
  DMS = 'DMS',
  NAVIGATION = 'NAVIGATION',
  SERVICE_CASE = 'SERVICE_CASE',
  USER = 'USER',
  VEHICLE = 'VEHICLE',
  OUTLET = 'OUTLET',
}
